export default {
    submitMainContainer: {
        display: "flex",
        flexDirection: "column",   
    },
    noteStyles: {
        
    }
}